import {useCallback, useLayoutEffect, useRef, useState} from "react";

export default function useSubmenuUI() {
    const [activeItem, setActiveItem] = useState(0);
    const [triangleTop, setTriangleTop] = useState(0);
    const [expandedMobileItems, setExpandedMobileItems] = useState(new Set([0]));
    const [isMobile, setIsMobile] = useState(false);

    const listRef = useRef(null);
    const itemsRef = useRef([]);

    const updateTrianglePosition = useCallback((index) => {
        const item = itemsRef.current[index];
        const container = listRef.current;
        const leftContainer = container?.parentElement;

        if (!item || !container || !leftContainer) return;

        const itemRect = item.getBoundingClientRect();
        const leftContainerRect = leftContainer.getBoundingClientRect();

        const itemTopRelative = itemRect.top - leftContainerRect.top;
        const itemHeight = itemRect.height;

        const topPosition = itemTopRelative + itemHeight / 2 - 12;
        setTriangleTop(topPosition);
    }, []);

    // Detect mobile
    useLayoutEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth <= 1310);
        };

        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);
        return () => window.removeEventListener("resize", checkIsMobile);
    }, []);

    const toggleMobileItem = useCallback((index) => {
        setExpandedMobileItems((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.clear();
                newSet.add(index);
            }
            return newSet;
        });
    }, []);

    const handleMouseEnter = useCallback(
        (index) => {
            setActiveItem(index);
            updateTrianglePosition(index);
        },
        [updateTrianglePosition],
    );

    const handleItemClick = useCallback(
        (index) => {
            if (isMobile) {
                toggleMobileItem(index);
            } else {
                setActiveItem(index);
                updateTrianglePosition(index);
            }
        },
        [isMobile, toggleMobileItem, updateTrianglePosition],
    );

    useLayoutEffect(() => {
        updateTrianglePosition(activeItem);
    }, [activeItem, updateTrianglePosition]);

    return {
        activeItem,
        setActiveItem,
        triangleTop,
        isMobile,
        expandedMobileItems,
        itemsRef,
        listRef,
        updateTrianglePosition,
        handleMouseEnter,
        handleItemClick,
        toggleMobileItem,
    };
}
